import React from 'react';

import './styles/style.scss';

import Label from './Label';

export const SmallLabel = props => <Label size="small" {...props} />;
SmallLabel.displayName = 'SmallLabel';
export const LargeLabel = props => <Label size="large" {...props} />;
LargeLabel.displayName = 'LargeLabel';

export default Label;



// WEBPACK FOOTER //
// ./src/components/Forms/Label/index.js